import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Luciole-Regular.css';
import './Jost.css'

import reportWebVitals from './reportWebVitals';
import App from './App';
import { logVersionInfo } from './config/version';

// Log version information to console for debugging
logVersionInfo();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
